/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/order */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  TablePagination,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  Card,
  CardMedia,
  Avatar,
  Box,
  InputAdornment,
  CardContent,
  CardActionArea,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  DialogContent,
  Checkbox,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import PercentIcon from '@mui/icons-material/Percent';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ImageIcon from '@mui/icons-material/Image';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import GridViewIcon from '@mui/icons-material/GridView';
import TableViewIcon from '@mui/icons-material/TableView';
import InventoryIcon from '@mui/icons-material/Inventory';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import AddIcon from '@mui/icons-material/Add';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import parse from 'html-react-parser';

const ProductCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  boxShadow: theme.shadows[1],
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[4],
    '& .product-actions': {
      opacity: 1,
    },
  },
}));

const ProductImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '180px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[100],
  overflow: 'hidden',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
  },
}));

const ProductActions = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  backgroundColor: 'rgba(0,0,0,0.5)',
  borderRadius: '0 0 0 8px',
  padding: theme.spacing(0.5),
}));

const ProductInfo = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
}));

const ImageGridContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

const ImageGridItem = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[100],
  aspectRatio: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}));

const AddImageButton = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `2px dashed ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[50],
  aspectRatio: '1/1',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[100],
  },
}));

// Quill editor modules configuration
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'image'];

const ProductInitialValue = {
  Category_Id: null,
  Brand: null,
  Product_Details_Description: '',
  Product_Details_Code: '',
  Rate: '',
  UOM: '',
  MRP: '',
  Tax: '',
  SellingPrice: '',
  Stock: 0,
  Description: '',
  Images: Array(5).fill(null),
  Active: 'Y',
  BOGO: 'N',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const Products = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [productsTableData, setProductsTableData] = useState([]);
  const [products, setProducts] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [brand, setBrand] = useState([])
  const [uomList, setUomList] = useState(['KG', 'LTR', 'PCS', 'BOX', 'BAG', 'METER']);
  const [UserId, setUserId] = useState(null);
  const [initialValue, setInitialValue] = useState(ProductInitialValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [viewMode, setViewMode] = useState('grid');
  const [imagePreviews, setImagePreviews] = useState(Array(5).fill(null));

  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    GetAllProducts();
    GetAllSubCategories();
    GetAllBrand()
  }, []);

  const GetAllBrand = async () => {
    try {
      showLoading();
      const response = await axios.get('Master/Brand/GetAllActiveBrand');
      setBrand(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();

  }

  const GetAllSubCategories = async () => {
    try {
      showLoading();
      const response = await axios.get('Master/SubCategory/GetAllSubCategory');
      setSubCategories(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const productValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        Category_Id: Yup.object().required('Please select Sub Category'),
        Product_Details_Description: Yup.string()
          .trim()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Product Name')
          .test('unique-product', 'This product already exists under this category', function (value) {
            const { Category_Id } = this.parent;
            if (!Category_Id || !value) return true;

            if (
              edit &&
              initialValue.Category_Id?.Category_Id === Category_Id.Category_Id &&
              initialValue.Product_Details_Description?.toLowerCase() === value?.toLowerCase()
            ) {
              return true;
            }

            return !products.some(
              (item) =>
                item.Category_Id === Category_Id.Category_Id &&
                item.Product_Details_Description?.toLowerCase() === value?.toLowerCase() &&
                item.Product_Details_Id !== initialValue.Product_Details_Id
            );
          }),
        Product_Details_Code: Yup.string().trim().nullable(),
        Rate: Yup.string().trim().nullable(),
        UOM: Yup.string().trim().required('UOM is required').max(20, 'UOM cannot exceed 20 characters'),
        MRP: Yup.string().trim().required('MRP is required'),
        Tax: Yup.string().trim().required('Tax is required'),
        SellingPrice: Yup.string().trim().required('Selling Price is required'),
        Stock: Yup.number().min(0, 'Stock cannot be negative').required('Stock is required'),
        Description: Yup.string().nullable(),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [products, initialValue, edit]
  );

  async function GetAllProducts() {
    try {
      showLoading();
      const response = await axios.get('Master/Products/GetAllProducts');
      setProducts(response.data);
      setProductsTableData(response.data);
      console.log(response.data);

    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleImageChange = (event, setFieldValue) => {
    const files = Array.from(event.target.files).slice(0, 5);
    if (files.length === 0) return;

    const newPreviews = [...imagePreviews];
    const newImages = [...initialValue.Images];

    files.forEach((file, index) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const firstEmptyIndex = newPreviews.findIndex((img) => img === null);
        if (firstEmptyIndex !== -1) {
          newPreviews[firstEmptyIndex] = reader.result;
          newImages[firstEmptyIndex] = file;
          setImagePreviews([...newPreviews]);
          setFieldValue(`Images[${firstEmptyIndex}]`, file);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index, setFieldValue) => {
    const newPreviews = [...imagePreviews];
    newPreviews[index] = null;
    setImagePreviews(newPreviews);
    setFieldValue(`Images[${index}]`, null);
  };

  async function InsertProduct(values) {
    console.log("values", values);

    try {
      const { Brand, Category_Id, Images, ...remainingValues } = values;
      const formData = new FormData();

      formData.append('Product_Details_Description', remainingValues.Product_Details_Description);
      formData.append('Product_Details_Code', remainingValues.Product_Details_Code || '');
      formData.append('Category_Id', Category_Id.Category_Id);
      formData.append('BrandId', Brand?.BrandId || 0);
      formData.append('Rate', remainingValues.Rate || '');
      formData.append('UOM', remainingValues.UOM || '');
      formData.append('MRP', remainingValues.MRP || '');
      formData.append('Tax', remainingValues.Tax || '');
      formData.append('SellingPrice', remainingValues.SellingPrice || '');
      formData.append('Stock', remainingValues.Stock || 0);
      formData.append('Description', remainingValues.Description || '');
      formData.append('Created_By', UserId);
      formData.append('Active', remainingValues.Active);
      formData.append('BOGO', remainingValues.BOGO);

      Images.forEach((image, index) => {
        if (image) {
          formData.append(`Image${index === 0 ? '' : index + 1}`, image);
        }
      });

      showLoading();
      await axios.post('Master/Products/InsertProducts', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      handleSubmitSuccess();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const UpdateProduct = async (values) => {
    try {
      console.log(values,'values')
      const { Brand, Category_Id, Images, ...remainingValues } = values;
      console.log(Brand,'Brand')
      const formData = new FormData();

      formData.append('Product_Details_Id', remainingValues.Product_Details_Id);
      formData.append('Product_Details_Description', remainingValues.Product_Details_Description);
      formData.append('Product_Details_Code', remainingValues.Product_Details_Code || '');
      formData.append('Category_Id', Category_Id.Category_Id);
      formData.append('BrandId', Brand?.BrandId || 0);
      formData.append('Rate', remainingValues.Rate || '');
      formData.append('UOM', remainingValues.UOM || '');
      formData.append('MRP', remainingValues.MRP || '');
      formData.append('Tax', remainingValues.Tax || '');
      formData.append('SellingPrice', remainingValues.SellingPrice || '');
      formData.append('Stock', remainingValues.Stock || 0);
      formData.append('Description', remainingValues.Description || '');
      formData.append('Modify_By', UserId);
      formData.append('Active', remainingValues.Active);
      formData.append('BOGO', remainingValues.BOGO);

      Images.forEach((image, index) => {
        const fieldName = `Image${index === 0 ? '' : index + 1}`;

        if (image instanceof File) {
          formData.append(fieldName, image);
        } else if (image === null || image === '') {
          formData.append(fieldName, '');
        } else {
          formData.append(fieldName, image || '');
        }
      });

      showLoading();
      await axios.post('Master/Products/UpdateProducts', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      handleSubmitSuccess();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Update failed!', 'error');
    }
    hideLoading();
  };

  const handleSubmitSuccess = () => {
    GetAllProducts();
    handleCloseDialog();
    openSnackBar(`Product ${edit ? 'Updated' : 'Added'} Successfully!`, edit ? 'warning' : 'success');
  };

  const DeleteProduct = async () => {
    try {
      showLoading();
      await axios.delete(`Master/Products/DeleteProducts/${deleteId}`);
      GetAllProducts();
      openSnackBar('Product Deleted Successfully!', 'warning');
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const subCategory = subCategories.find((cat) => cat.Category_Id === values.Category_Id);
    const Bran = brand.find((br) => br.BrandId === values.BrandId)
    const newPreviews = Array(5).fill(null);
    const newImages = Array(5).fill(null);

    for (let i = 0; i < 5; i++) {
      const imageKey = `Image${i === 0 ? '' : i + 1}`;
      if (values[imageKey]) {
        newPreviews[i] = `${axios.defaults.products}/${values[imageKey]}`;
        newImages[i] = values[imageKey];
      }
    }

    setInitialValue({
      ...values,
      Category_Id: subCategory || null,
      Brand: Bran || null,
      Images: newImages,
    });

    setImagePreviews(newPreviews);
    setEdit(true);
    setOpen(true);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  useEffect(() => {
    const newTableData = products.filter(
      (product) =>
        `${product.Product_Details_Description} ${product.Category_Description} ${product.Product_Details_Code} ${product.Rate} ${product.UOM} ${product.MRP} ${product.SellingPrice} ${product.Stock}`
          .toLowerCase()
          .includes(filterData.searchTerm?.toLowerCase()) && product.Active === (filterData.Active ? 'Y' : 'N')
    );
    if (page > 0) setPage(0);
    setProductsTableData(newTableData);
  }, [products, filterData]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEdit(false);
    setInitialValue(ProductInitialValue);
    setImagePreviews(Array(5).fill(null));
  };

  const handleImagePreview = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = productsTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [productsTableData, page, rowsPerPage]);

  const toggleViewMode = () => {
    setViewMode(viewMode === 'grid' ? 'table' : 'grid');
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* Header Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: 'background.paper', borderRadius: 3 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h4" fontWeight="bold" color="text.primary">
                Product Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage your product inventory and listings
              </Typography>
            </Grid>
            <Grid item>
              <Stack direction="row" spacing={2} alignItems="center">
                <Tooltip title={viewMode === 'grid' ? 'Switch to Table View' : 'Switch to Grid View'}>
                  <IconButton
                    onClick={toggleViewMode}
                    sx={{
                      backgroundColor: 'action.hover',
                      '&:hover': { backgroundColor: 'action.selected' },
                    }}
                  >
                    {viewMode === 'grid' ? <TableViewIcon /> : <GridViewIcon />}
                  </IconButton>
                </Tooltip>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(true)}
                  startIcon={<PlaylistAddIcon />}
                  sx={{
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    fontWeight: 600,
                  }}
                >
                  Add New Product
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        {/* Filter Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: 'background.paper', borderRadius: 3 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                variant="outlined"
                color="primary"
                label="Search Products"
                size="small"
                placeholder="Search by name, category, code, price or stock"
                onChange={(e) => handleFilterDataChange('searchTerm', e.target.value)}
                value={filterData.searchTerm}
                InputProps={{
                  sx: { borderRadius: 2 },
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
                <Typography variant="body1" fontWeight={500}>
                  Show Active Only
                </Typography>
                <Switch
                  size="small"
                  checked={filterData.Active}
                  onChange={(e) => handleFilterDataChange('Active', e.target.checked)}
                  color="primary"
                />
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        {viewMode === 'grid' ? (
          /* Products Grid View */
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {(rowsPerPage > 0
              ? productsTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : productsTableData
            ).map((product) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={product.Product_Details_Id}>
                <ProductCard>
                  <ProductImageWrapper>
                    {product.Image ? (
                      <img
                        src={`${axios.defaults.products}/${product.Image}`}
                        alt={product.Product_Details_Description}
                      />
                    ) : (
                      <Avatar sx={{ width: 80, height: 80, bgcolor: 'grey.300' }}>
                        <ImageIcon fontSize="large" color="disabled" />
                      </Avatar>
                    )}
                    <ProductActions className="product-actions">
                      <Tooltip title="Edit">
                        <IconButton
                          size="small"
                          color="inherit"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(product);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          size="small"
                          color="inherit"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(product.Product_Details_Id);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </ProductActions>
                  </ProductImageWrapper>
                  <ProductInfo>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      {product.Product_Details_Description}
                    </Typography>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Chip
                        label={product.Category_Description}
                        color="primary"
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 600 }}
                      />
                      <Chip
                        label={product.Active === 'Y' ? 'Active' : 'Inactive'}
                        color={product.Active === 'Y' ? 'success' : 'error'}
                        size="small"
                        variant="outlined"
                        icon={product.Active === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                      />
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        Code: {product.Product_Details_Code || 'N/A'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        UOM: {product.UOM}
                      </Typography>
                    </Box>
                     <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        Brand: {product.Brand_Description}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      {/* <Typography variant="subtitle2" fontWeight={600} color="primary">
                        {product.Rate ? `₹${product.Rate}` : '₹ ---'}
                      </Typography> */}
                      <Typography variant="subtitle2" fontWeight={600} color="primary">
                        Selling Price: {product.SellingPrice ? `₹${product.SellingPrice}` : '₹ ---'}
                      </Typography>
                      <Typography variant="subtitle2" fontWeight={600} color="secondary">
                        MRP: {product.MRP ? `₹${product.MRP}` : '₹ ---'}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      {/* <Typography variant="subtitle2" fontWeight={600} color="success.main">
                        Selling: {product.SellingPrice ? `₹${product.SellingPrice}` : '₹ ---'}
                      </Typography> */}
                      <Typography variant="subtitle2" color="text.secondary">
                        Stock: {product.Stock || 0}
                      </Typography>
                    </Box>
                    {/* {product.Description && (
                      <Box mt={1}>
                        <Typography variant="caption" color="text.secondary">
                          Description:
                        </Typography>
                        <Box
                          sx={{
                            maxHeight: 100,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            '& *': {
                              margin: 0,
                              padding: 0,
                              fontSize: '0.75rem !important',
                              lineHeight: '1.2 !important',
                            },
                          }}
                        >
                          {parse(product.Description)}
                        </Box>
                      </Box>
                    )} */}
                  </ProductInfo>
                </ProductCard>
              </Grid>
            ))}
          </Grid>
        ) : (
          /* Products Table View */
          <TableContainer component={Paper} elevation={0} sx={{ mb: 3, borderRadius: 3 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: 'blue' }}>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Image</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Product Name</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Category</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Brand</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Code</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>UOM</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Rate</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>MRP</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Selling Price</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Stock</TableCell>
                  <TableCell sx={{ color: 'grey', fontWeight: 600 }}>Status</TableCell>
                  <TableCell align="center" sx={{  color: 'grey', fontWeight: 600 }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? productsTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : productsTableData
                ).map((product) => (
                  <TableRow key={product.Product_Details_Id} hover>
                    <TableCell>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleImagePreview(`${axios.defaults.products}/${product.Image}`)}
                      >
                        {product.Image ? (
                          <img
                            src={`${axios.defaults.products}/${product.Image}`}
                            alt={product.Product_Details_Description}
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              objectFit: 'contain',
                              borderRadius: '4px',
                            }}
                          />
                        ) : (
                          <Avatar sx={{ width: 40, height: 40, bgcolor: 'grey.300' }}>
                            <ImageIcon fontSize="small" color="disabled" />
                          </Avatar>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{product.Product_Details_Description}</TableCell>
                    <TableCell>{product.Category_Description}</TableCell>
                     <TableCell>{product.Brand_Description}</TableCell>
                    <TableCell>{product.Product_Details_Code || 'N/A'}</TableCell>
                    <TableCell>{product.UOM}</TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{product.Rate ? `₹${product.Rate}` : '---'}</TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{product.MRP ? `₹${product.MRP}` : '---'}</TableCell>
                    <TableCell sx={{ fontWeight: 500, color: 'success.main' }}>
                      {product.SellingPrice ? `₹${product.SellingPrice}` : '---'}
                    </TableCell>
                    <TableCell>{product.Stock || 0}</TableCell>
                    <TableCell>
                      <Chip
                        label={product.Active === 'Y' ? 'Active' : 'Inactive'}
                        color={product.Active === 'Y' ? 'success' : 'error'}
                        size="small"
                        variant="outlined"
                        icon={
                          product.Active === 'Y' ? (
                            <CheckCircleOutlineIcon fontSize="small" />
                          ) : (
                            <HighlightOffIcon fontSize="small" />
                          )
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Edit Product">
                        <IconButton size="small" color="primary" onClick={() => handleEditClick(product)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete Product">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => {
                            setDeleteId(product.Product_Details_Id);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 73 * emptyRows }}>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Pagination */}
        <Box display="flex" justifyContent="center" mt={3}>
          <TablePagination
            rowsPerPageOptions={[12, 24, 36, { label: 'All', value: -1 }]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            sx={{
              '& .MuiTablePagination-toolbar': {
                padding: 1,
              },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                marginBottom: 0,
              },
            }}
          />
        </Box>

        {/* Add/Edit Product Dialog */}
        <Dialog maxWidth={'lg'} open={open} onClose={handleCloseDialog} fullWidth>
          <DialogTitle id="scroll-dialog-title">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="bold" color="text.primary">
                {edit ? 'Edit Product' : 'Add New Product'}
              </Typography>
              <IconButton onClick={handleCloseDialog} size="large">
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider />
          </DialogTitle>
          <DialogContent>
            <Paper elevation={0} sx={{ pt: 2 }}>
              <Formik
                validationSchema={productValidationSchema}
                initialValues={initialValue}
                onSubmit={async (values, { resetForm }) => {
                  if (edit) await UpdateProduct(values);
                  else await InsertProduct(values);
                  resetForm();
                }}
                enableReinitialize
              >
                {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                  <Form>
                    <Grid container spacing={3}>
                      {/* Form Fields */}
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Product Name"
                          name="Product_Details_Description"
                          onBlur={handleBlur}
                          required
                          error={touched.Product_Details_Description && !!errors.Product_Details_Description}
                          helperText={touched.Product_Details_Description && errors.Product_Details_Description}
                          value={values.Product_Details_Description}
                          onChange={handleChange}
                        />
                      </Grid>


                      <Grid item xs={12} md={4}>
                        <Autocomplete
                          options={subCategories}
                          size="small"
                          getOptionLabel={(option) => option.Category_Description}
                          isOptionEqualToValue={(option, value) => option.Category_Id === value?.Category_Id}
                          value={values.Category_Id}
                          onChange={(event, newValue) => {
                            setFieldValue('Category_Id', newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Product Category"
                              required
                              fullWidth
                              error={touched.Category_Id && !!errors.Category_Id}
                              helperText={touched.Category_Id && errors.Category_Id}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Autocomplete
                          options={brand}
                          size="small"
                          getOptionLabel={(option) => option?.Brand_Description ? option.Brand_Description : ""}
                          isOptionEqualToValue={(option, value) => option.BrandId === value?.BrandId}
                          value={values.Brand || null}
                          onChange={(event, newValue) => {
                            setFieldValue('Brand', newValue || null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Brand"
                              fullWidth
                              error={touched.Brand && !!errors.Brand}
                              helperText={touched.Brand && errors.Brand}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Product Code (Optional)"
                          name="Product_Details_Code"
                          onBlur={handleBlur}
                          error={touched.Product_Details_Code && !!errors.Product_Details_Code}
                          helperText={touched.Product_Details_Code && errors.Product_Details_Code}
                          value={values.Product_Details_Code}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="UOM"
                          name="UOM"
                          required
                          onBlur={handleBlur}
                          error={touched.UOM && !!errors.UOM}
                          helperText={touched.UOM && errors.UOM}
                          value={values.UOM}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="MRP"
                          name="MRP"
                          required
                          onBlur={handleBlur}
                          error={touched.MRP && !!errors.MRP}
                          helperText={touched.MRP && errors.MRP}
                          value={values.MRP}
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocalOfferIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Tax"
                          name="Tax"
                          required
                          onBlur={handleBlur}
                          error={touched.Tax && !!errors.Tax}
                          helperText={touched.Tax && errors.Tax}
                          value={values.Tax}
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PercentIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Selling Price"
                          name="SellingPrice"
                          required
                          onBlur={handleBlur}
                          error={touched.SellingPrice && !!errors.SellingPrice}
                          helperText={touched.SellingPrice && errors.SellingPrice}
                          value={values.SellingPrice}
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PriceCheckIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Stock"
                          name="Stock"
                          type="number"
                          required
                          onBlur={handleBlur}
                          error={touched.Stock && !!errors.Stock}
                          helperText={touched.Stock && errors.Stock}
                          value={values.Stock}
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <InventoryIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="BOGO"
                              checked={values.BOGO === 'Y'}
                              onChange={(e) => {
                                setFieldValue('BOGO', e.target.checked ? 'Y' : 'N');
                              }}
                              onBlur={handleBlur}
                            />
                          }
                          label="Buy 1 Get 1 Offer"
                        />
                      </Grid>

                      {/* Rich Text Editor for Description */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Product Description
                        </Typography>
                        <Box
                          sx={{
                            height: 200,
                            '& .ql-container': {
                              height: 'calc(100% - 42px)',
                            },
                          }}
                        >
                          <ReactQuill
                            theme="snow"
                            value={values.Description || ''}
                            onChange={(value) => setFieldValue('Description', value)}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: '100%' }}
                          />
                        </Box>
                      </Grid>

                      {/* Image Upload Section */}
                      <Grid item xs={12}>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                          Product Images
                        </Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          Upload up to 5 images (First image will be the main display image)
                        </Typography>

                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="product-images-upload"
                          type="file"
                          multiple
                          onChange={(e) => handleImageChange(e, setFieldValue)}
                        />
                        <label htmlFor="product-images-upload">
                          <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            startIcon={<AddPhotoAlternateIcon />}
                          >
                            Upload Images (Max 5)
                          </Button>
                        </label>
                        {imagePreviews && (
                          <ImageGridContainer>
                            {imagePreviews.map((preview, index) => (
                              <ImageGridItem key={index}>
                                {preview ? (
                                  <>
                                    <img src={preview} alt={`Product Preview ${index + 1}`} />
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => removeImage(index, setFieldValue)}
                                      sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        backgroundColor: 'rgba(255,255,255,0.7)',
                                        '&:hover': {
                                          backgroundColor: 'rgba(255,255,255,0.9)',
                                        },
                                      }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </>
                                ) : (
                                  <AddImageButton
                                    onClick={() => document.getElementById('product-images-upload').click()}
                                  >
                                    <AddIcon color="action" />
                                    <Typography variant="caption" color="text.secondary">
                                      Add Image
                                    </Typography>
                                  </AddImageButton>
                                )}
                              </ImageGridItem>
                            ))}
                          </ImageGridContainer>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl component="fieldset" fullWidth>
                          <FormLabel component="legend">Active Status</FormLabel>
                          <RadioGroup row value={values.Active} name="Active" onChange={handleChange}>
                            <FormControlLabel value="Y" control={<Radio color="primary" size="small" />} label="Yes" />
                            <FormControlLabel value="N" control={<Radio color="error" size="small" />} label="No" />
                          </RadioGroup>
                          {errors.Active && touched.Active && (
                            <Typography variant="caption" color="error">
                              {errors.Active}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      {/* Form Actions */}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 2 }} />
                        <Box display="flex" justifyContent="flex-end" gap={2}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCloseDialog}
                            disabled={isSubmitting}
                            sx={{
                              borderRadius: 2,
                              px: 3,
                              py: 1,
                              minWidth: 120,
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                            size="small"
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            color={edit ? 'warning' : 'primary'}
                            onClick={submitForm}
                            size="small"
                            disabled={isSubmitting}
                            sx={{
                              borderRadius: 2,
                              px: 3,
                              py: 1,
                              minWidth: 150,
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                          >
                            {edit ? 'Update Product' : 'Add Product'}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Paper>
          </DialogContent>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} maxWidth="xs" fullWidth>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold">
                Confirm Delete
              </Typography>
            </DialogTitle>
            <Box p={2}>
              <Typography>Are you sure you want to delete this product? This action cannot be undone.</Typography>
            </Box>
            <DialogActions sx={{ p: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCloseDelete}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={DeleteProduct}
                autoFocus
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Delete
              </Button>
            </DialogActions>
          </Paper>
        </Dialog>

        {/* Image Preview Dialog */}
        <Dialog open={openImageDialog} onClose={handleCloseImageDialog} maxWidth="md" fullWidth>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold">
                Product Image Preview
              </Typography>
            </DialogTitle>
            <Box p={2} display="flex" justifyContent="center">
              <Card sx={{ maxWidth: '100%', borderRadius: 2 }}>
                <CardMedia
                  component="img"
                  image={selectedImage}
                  alt="Product Image"
                  sx={{ maxHeight: '70vh', objectFit: 'contain' }}
                />
              </Card>
            </Box>
            <DialogActions>
              <Button
                onClick={handleCloseImageDialog}
                color="primary"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Paper>
        </Dialog>
      </Container>
    </>
  );
};

export default Products;
